import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {BlockService} from '../../../service/BlockService';
import { Validation } from '../../../model/validation';
import { MessageService } from '../../../service/message.service';
import { messageTypes } from '../../../helpers/MessageTypes';
import { MAX_DEPASSMENT } from '../../../helpers/GlobalConstants';
import { OpenFicheService } from '../../../service/open-fiche.service';
import { Observable } from 'rxjs';
import { SessionService } from '../../../service/SessionService';

@Component({
  selector: 'app-validate-demande-dialog',
  templateUrl: './validate-demande-dialog.component.html',
  styleUrls: ['./validate-demande-dialog.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ValidateDemandeDialogComponent implements OnInit {
  user: any;
  loadingIndicator = false;
  idDemande;
  idsDemande;
  from: string;
  callback: (id) => Observable<any>;
  constructor(public dialogRef: MatDialogRef<ValidateDemandeDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private blockservice: BlockService,
              private messageService: MessageService,
              private openFicheService: OpenFicheService,
              private session: SessionService) { }

  ngOnInit() {
    this.idDemande = this.data.id;
    this.idsDemande = this.data.ids;
    this.callback = this.data.callback;
    this.from = this.data.from;

  }
  public CloseDialog() {
    this.dialogRef.close();
    this.messageService.sendMessage(messageTypes.LOADING);
  }

  public Validation() {
    this.loadingIndicator = true;
    // this.openFicheService.validateRequest(this.idDemande).subscribe(res => {
    //   this.messageService.sendMessage(messageTypes.LOADING);
    //   this.loadingIndicator = false;
    //   this.dialogRef.close();
    // })
    const callback = this.idsDemande?this.callback(this.idsDemande):this.callback(this.idDemande);
    callback.subscribe(res => {
    this.messageService.sendMessage(messageTypes.LOADING);
    this.loadingIndicator = false;
    this.dialogRef.close(true);
    },
    error => this.session.redirectBadRequest(error)
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/view/block-temps/validate-demande-dialog/validate-demande-dialog.component.ts